import { gql } from '@/__generated__/index.ts';

gql(`
  fragment TimeSeriesFragment on TimeSeries {
    id
    name
    description
    unit
    isOwner
  }
`);

export const StreamHasTimeSeriesQuery = gql(`
  query StreamHasTimeSeries($id: ID!) {
    streamHasTimeSeries(streamId: $id)
  }
`);

export const StreamTimeSeriesQuery = gql(`
  query StreamTimeSeries($streamId: ID!) {
    streamTimeSeries(streamId: $streamId) {
      ...TimeSeriesFragment
    }
  }
`);

export const TimeSeriesLabelsQuery = gql(`
  query TimeSeriesLabels($seriesId: UUID!, $streamId: ID) {
    timeSeriesLabels(seriesId: $seriesId, streamId: $streamId) {
      key
      values
    }
  }
`);

export const TimeSeriesLinesQuery = gql(`
  query TimeSeriesLines($input: TimeSeriesLinesInput!) {
    timeSeriesLines(input: $input) {
      matched
      lines {
        labels {
          key
          value
        }
        bars {
          time
          open
          high
          low
          close
        }
      }
    }
  }
`);

export const TimeSeriesLatestQuery = gql(`
  query TimeSeriesLatest($input: TimeSeriesReadInput!) {
    timeSeriesLatest(input: $input) {
      labels {
        key
        value
      }
      time
      value
    }
  }
`);

export const CreateTimeSeriesMutation = gql(`
  mutation CreateTimeSeries(
    $name: String!
    $unit: String
    $description: String
    $streamId: ID
  ) {
    createTimeSeries(
      name: $name
      unit: $unit
      description: $description
      streamId: $streamId
    ) {
      ...TimeSeriesFragment
    }
  }
`);

export const DeleteTimeSeriesMutation = gql(`
  mutation DeleteTimeSeries($seriesId: UUID!) {
    deleteTimeSeries(seriesId: $seriesId)
  }
`);
